import { render, staticRenderFns } from "./Workers.vue?vue&type=template&id=61723808&scoped=true"
import script from "./Workers.vue?vue&type=script&lang=ts"
export * from "./Workers.vue?vue&type=script&lang=ts"
import style0 from "./Workers.vue?vue&type=style&index=0&id=61723808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61723808",
  null
  
)

export default component.exports